import React, { useState, useEffect } from "react";
import './styles/userTrack.css';

function Usertracking() {
  const [count, setCount] = useState("");

  useEffect(() => {
    const ping = () => {
      fetch("https://samahomecare.com/api/track.php")
        .then(res => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then(data => setCount(data.activeUsers))
        .catch(error => console.error("Fetch error:", error));
    };

    ping();
    const interval = setInterval(ping, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <p className="usertracking">
      {count > 0 ? `${count} user(s) Online` : "Error With the Code"}
    </p>
  );
}

export default Usertracking;
